export default function registerOtpInput(Alpine) {
  Alpine.data("otpInput", () => ({
    digits: ["", "", "", "", "", ""],
    init() {
      this.$nextTick(() => this.$refs.cell0?.focus());
    },
    onInput(idx, e) {
      const v = e.target.value.replace(/\D/g, "").slice(-1);
      this.digits[idx] = v;
      e.target.value = v;
      if (v && idx < 5) this.$refs[`cell${idx + 1}`]?.focus();
      this.syncHidden();
    },
    onKeyDown(idx, e) {
      if (e.key === "Backspace" && !this.digits[idx] && idx > 0) {
        this.$refs[`cell${idx - 1}`]?.focus();
      }
      if (e.key === "ArrowLeft" && idx > 0) this.$refs[`cell${idx - 1}`]?.focus();
      if (e.key === "ArrowRight" && idx < 5) this.$refs[`cell${idx + 1}`]?.focus();
    },
    onPaste(e) {
      const text = (e.clipboardData || window.clipboardData).getData("text") || "";
      const clean = text.replace(/\D/g, "").slice(0, 6).split("");
      if (clean.length === 0) return;
      e.preventDefault();
      clean.forEach((d, i) => {
        this.digits[i] = d;
        if (this.$refs[`cell${i}`]) this.$refs[`cell${i}`].value = d;
      });
      this.syncHidden();
      const last = Math.min(clean.length, 5);
      this.$refs[`cell${last}`]?.focus();
      if (clean.length === 6) e.target.closest("form")?.requestSubmit();
    },
    syncHidden() {
      if (this.$refs.code) this.$refs.code.value = this.digits.join("");
    }
  }));
}
